<template>
  <div class="post" @click="goToPost">
    <div class="by"><leech-logo :color="iconHexColor"></leech-logo></div>
    <div class="block">
      <div class="creation">
        {{ createdDateTime }} - {{ createdByUserName }}
      </div>
      <div class="content">{{ postTitle }}</div>
      <div class="info">
        <div class="bit">{{ commentCount }} kommentarer</div>
        |
        <div class="bit">{{ likes }} igler</div>
        |
        <div class="bit">{{ dislikes }} pikke</div>
      </div>
    </div>
  </div>
</template>
<script>
import router from "../router";
import LeechLogo from "./LeechLogo.vue";

export default {
  components: {
    LeechLogo,
  },
  props: {
    forumPostId: Number,
    postTitle: String,

    postImage: String,

    iconHexColor: String,
    createdDateTime: String,

    comments: {
      type: Array,
    },
    likes: {
      type: Number,
      default: 0,
    },
    dislikes: {
      type: Number,
      default: 0,
    },

    createdByUserName: String,
  },
  computed: {
    commentCount() {
      return this.comments?.length ?? 0;
    },
  },
  methods: {
    goToPost() {
      router.push("/igler/post/" + this.forumPostId);
    },
  },
};
</script>
<style lang="scss" scoped>
.post {
  max-width: calc(100% - 30px);
  width: 1000px;
  background-color: #ffffff;
  box-shadow: 0 0 10px #999999;
  box-sizing: border-box;
  border-radius: 12px;
  padding: 10px;
  border-radius: 6px;
  margin-bottom: 30px;
  position: relative;

  transition: box-shadow 0.2s, width 0.2s;

  .by {
    position: absolute;
    top: 5px;
    left: -70px;
    height: 60px;
    width: 60px;
    padding: 5px;
    box-sizing: border-box;
    border-radius: 50%;
    background-color: #ffffff;
    box-shadow: 0 0 10px #999999;
  }

  &:hover {
    cursor: pointer;
    box-shadow: 0 0 10px #333333;
  }

  .block {
    width: 100%;

    .creation {
      font-size: 13px;
      font-style: italic;
      color: #666666;
    }

    .content {
      padding: 20px 10px;
      font-size: 16px;
      font-weight: bold;
    }

    .info {
      font-size: 13px;
      font-style: italic;
      color: #333333;
      display: flex;

      .bit {
        font-size: inherit;
        font-style: inherit;
        margin: 0 10px;
      }
    }
  }
}

@media only screen and (max-width: 1150px) {
  .post {
    margin: 80px 0 20px;

    .by {
      top: -70px;
      left: 5px;
    }
  }
}
</style>
